import {
  FiBriefcase,
  FiAlertCircle,
  FiUsers,
  FiPieChart,
  FiGitBranch,
  FiTrendingUp,
  FiDatabase,
  FiCheckCircle,
  FiBell,
  FiSettings,
  FiCalendar,
  FiDollarSign,
  FiCreditCard,
  FiBook,
  FiActivity,
} from 'react-icons/fi';

/** Routes hidden from sidebar (code/routes may remain for later). */
export const HIDDEN_NAV_PATHS = new Set(['/releases']);

/** Routes that must appear for every signed-in user (not gated by role_permissions). */
export const ALWAYS_ON_NAV_PATHS = new Set(['/my-tasks']);

/**
 * Sidebar items driven by `user.permissions` (stable keys from backend).
 * Order is intentional — matches product nav layout.
 */
export const NAV_BY_PERMISSION = [
  { path: '/dashboard', label: 'Dashboard', permission: 'nav.dashboard', Icon: FiPieChart },
  { path: '/projects', labelKey: 'projects', permission: 'nav.projects', Icon: FiBriefcase },
  { path: '/tracker', label: 'Tracker', permission: 'nav.tracker', Icon: FiActivity },
  { path: '/budget', label: 'Budget', permission: 'nav.budget', Icon: FiDollarSign },
  { path: '/expense-claims', label: 'Expense Claims', anyPermission: ['nav.expense_claims', 'nav.expense_claims.approvals'], Icon: FiCreditCard },
  { path: '/sprint-board', label: 'Sprint Board', permission: 'nav.sprint_board', Icon: FiGitBranch },
  { path: '/daily-notebook', label: 'Daily Notebook', permission: 'nav.daily_notebook', Icon: FiBook },
  { path: '/issues', label: 'Issues', permission: 'nav.issues', Icon: FiAlertCircle },
  { path: '/team-activity', label: 'Team Activity', permission: 'nav.team_activity', Icon: FiTrendingUp },
  { path: '/users-management', labelKey: 'users', permission: 'nav.users_management', Icon: FiUsers },
  { path: '/bitbucket-admin', label: 'Bitbucket', permission: 'nav.bitbucket', Icon: FiDatabase },
  { path: '/my-tasks', labelKey: 'myTasks', Icon: FiCheckCircle },
  { path: '/developer-activity', label: 'Developer Activity', permission: 'nav.developer_activity', Icon: FiTrendingUp },
  { path: '/notifications', label: 'Notifications', permission: 'nav.notifications', Icon: FiBell },
  { path: '/team-leave', label: 'Leave calendar', permission: 'nav.leave_calendar', Icon: FiCalendar },
  { path: '/settings', label: 'Settings', anyPermission: ['settings.email.edit', 'permissions.matrix.edit'], Icon: FiSettings },
];

/** Admin/superadmin always see User Management — not gated by matrix edits. */
export const ADMIN_TEAM_ROLES = new Set(['admin', 'superadmin']);

/**
 * Developer Activity is a personal commit/PR feed, so it's hidden from the
 * roles that oversee work rather than do it. Team Activity is the equivalent
 * view for them.
 */
export const DEVELOPER_ACTIVITY_HIDDEN_ROLES = new Set([
  'superadmin',
  'admin',
  'manager',
  'hod',
  'marketing_manager',
  'brand_manager',
  'pr_manager',
  'product_manager',
]);

export const USER_MANAGEMENT_NAV_LABEL = 'User Management';

export function labelForNavItem(item, roleLower) {
  if (item.label) return item.label;
  if (item.labelKey === 'projects') {
    return ['superadmin', 'admin'].includes(roleLower) ? 'All Projects' : 'My Projects';
  }
  if (item.labelKey === 'users') {
    return USER_MANAGEMENT_NAV_LABEL;
  }
  if (item.labelKey === 'myTasks') {
    return 'My Tasks';
  }
  return item.label || '';
}
